module.exports = __webpack_public_path__ + "img/close-up.af53cbf5.png";